export enum HotKeyTypes {
    Other = -1,
    PinTicketSmall = 0,
    PinTicketMedium = 1,
    PinTicketLarge = 2,
    PinTicketKingSize = 3,
    RangeCard = 4,
    RangeCardAuto = 5,
    SaleItem = 6,
    PinTicketCustom = 7,
    PinTicketCategory = 8,
    TurnstileEntry = 9,
    TBox = 10,
    GiftCard = 11,
    Route = 100,
    Clickable = 101
}

export enum ButtonTypes {
    Route = 100,
    Clickable = 101,
    Action = 101,
    Other = 200
}

export enum DiscountTypes {
    Amount = 0,
    Rate = 1
}

export enum InventoryTypes {
    Inventory = 0,
    PinTicket = 1,
    Reload = 2,
    TBox = 3,
    GiftCard = 4,
    Other = 5,
    OpenRange = 6
}

export enum CustomerRelationshipTypes {
    Unknown = 0,
    Single = 1,
    Parent = 2,
    Child = 3
}

export enum BucketSize {
    Small = 0,
    Medium = 1,
    Large = 2,
    King = 3,
    Free = 4
}

export enum StationTypes {
    Dispenser = 1,
    Turnstile = 2,
    TBox = 3,
    TBoxRAS = 4,
    Virtual = 5,
    TBoxGreenJoy = 6
}

export enum CategoryStatusType {
    NotActive = 0,
    DiscountAndBonus = 1,
    HappyHour1 = 2,
    HappyHour2 = 3,
    HappyHour3 = 4,
    HappyHour4 = 5
}

export enum CartStatusTypes {
    Unknown = 0,
    NotStarted = 1,
    Processing = 2,
    Paid = 3,
    Rollback = 100
}

export enum CartPaymentTypes {
    Unknown = 0,
    Cash = 1,
    Credit = 2,
    Gift = 3
}

export enum CartPaymentStatusTypes {
    Unknown = 0,
    NotPaid = 1,
    Processing = 2,
    Paid = 3,
    Rollback = 100
}

export enum CartProcessingTypes {
    Sale = 0,
    Refund = 1
}

export enum PosCardReaderTypes {
    Bezel8 = 0,
    Augusta = 1,
    CardPointeTerminal = 2
}

export enum InventoryItemHistoryTypes {
    Unknown = 0,
    Received = 1,
    Adjusted = 2,
    Sold = 3,
    Refunded = 4
}
export enum PaymentProcessorTypes {
    None = 0,
    Pineapple = 1,
    WorldPay = 2,
    Stripe = 4,
    LatPay = 7,
    GlobalPay = 9,

}

export enum DesignerTypes {
    None = 0,
    POS = 1,
    Cashier = 2,
    RangeCard = 3,
    PinTicket = 4
}

export enum PaymentServiceTypes {
    None = 0,
    Pineapple = 1,
    Stripe = 2,
    WorldPay = 3,
    Verifone = 4,
    Adyen = 5,
    Chase = 9
}

export enum CardReaderTypes {
    Unknown = 0,
    Bezel8 = 1,
    DataCap = 2,
    CardPointe = 3,
    VP5300 = 4,
    VP3300 = 9,
    QrCode = 12,
    None = 1000
}

export enum PulseProfileTypes {
    RangeServant = 0,
    Wittek = 1,
    TimedPitch = 2
}

export enum RefundableStatusTypes {
    Unknown = 0,
    Refundable = 1,
    Voided = 2,
    Refunded = 3
}

export enum TransactionStatusTypes {
    NotStarted = 0,
    InProgress = 1,
    Approved = 4,
    Completed = 101,
    CompletedNotAuthorized = 102,
    Voided = 201,
    Refunded = 301,
    NotApproved = 401,
}


export enum JobStatusTypes {
    Unknown = -1,
    Launched = 0,
    Started = 1,
    Completed = 100,
    Failed = 200,
    Cancelling = 300,
    Cancelled = 301
}

export enum JobActionTypes {
    Unknown = -1,
    Link = 0,
    Download = 1,
    Message = 2
}

export enum LocationProcessorTypes {
    Unknown = -1,
    CardPointe = 0,
    Chase = 1,    
}

export enum ReportExportTypes {
    None = 0,
    BallsDispensed = 1,    
}

export enum MobilePurchaseActionTypes
{
    Dispense = 0,
    Pincode = 1
}

export enum SquareOrderActionTypes
{
    NoAction = 0,
    NeedsAction = 1,
    CompleteManually = 2,
    CompleteAutomatically = 3
}

export enum BayStatusTypes
{
    Unknown = 0,
    Available = 1,
    InUse = 2,
    Cleaning = 3,
    OutOfOrder = 4,
    // Bay with multiple devices reporting disagreeing statuses (server-side merged status).
    Conflicted = 5,
    // Bay with no device fitted in it - nothing can activate it, so it is never available to sell.
    NothingToActivate = 6
}

export enum VirtualPurchaseTypes
{
    PincodePurchase = 0,
    MemberReload = 1,
    CustomerPortal = 2
}
